"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const ArrowForward_1 = __importDefault(require("@mui/icons-material/ArrowForward"));
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../decorators/withStore"));
const helpers_1 = require("../../helpers/helpers");
const Wrapper = styled_components_1.default.div `
  max-width: 488px;
  margin: 16px auto 0;
  padding: 16px 0;

  .link {
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    color: #212121;
    display: block;
    padding: 16px;
    transition: all 1s ease-in-out;

    &:hover .forward-icon {
      transition: all 0.4s ease-in-out;
      transform: translateX(5px);
    }
  }
`;
const CountDownBox = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;

  .countdown {
    display: flex;
    align-items: center;

    &-value {
      span:last-of-type {
        margin: 0 1.8vmin;
      }

      span {
        background: rgba(33, 33, 33, 0.08);
        border-radius: 4px;
        padding: 1vmin 2vmin;
        font-size: 4.2vmin;
      }
    }
  }

  .trip-details {
    p:last-of-type {
      font-weight: 500;
    }
  }

  .forward-icon {
    border: 1.8px solid #000;
    border-radius: 50%;
    padding: 5px;
    line-height: 10px;
  }
`;
const NextStayCountDown = (props) => {
    const { userData: { stays }, } = props;
    const tripInfo = stays && stays[0];
    const countDownDays = tripInfo &&
        Math.ceil(helpers_1.Helpers.getDaysBetweenDates(new Date(), new Date(tripInfo.startsOn)));
    const twoDigitValue = countDownDays >= 10 ? countDownDays.toString() : "";
    return (countDownDays <= 30 &&
        countDownDays >= 0 && (react_1.default.createElement(Wrapper, { "data-testid": "count-down-section" },
        react_1.default.createElement(react_router_dom_1.Link, { to: tripInfo.venue.slug, className: "link" },
            react_1.default.createElement(CountDownBox, null,
                react_1.default.createElement(material_1.Box, { className: "countdown" },
                    react_1.default.createElement(material_1.Typography, { className: "countdown-value" }, countDownDays < 10 ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("span", null, "0"),
                        react_1.default.createElement("span", null, countDownDays))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("span", null, twoDigitValue.charAt(0)),
                        react_1.default.createElement("span", null, twoDigitValue.charAt(1))))),
                    react_1.default.createElement(material_1.Box, { className: "trip-details" },
                        react_1.default.createElement(material_1.Typography, null,
                            " ",
                            i18n_js_1.default.t("stay_countdown_text"),
                            " "),
                        react_1.default.createElement(material_1.Typography, null,
                            " ",
                            tripInfo.venue.name,
                            " "))),
                react_1.default.createElement(material_1.Box, { className: "forward-icon" },
                    react_1.default.createElement(ArrowForward_1.default, { fontSize: "small" })))))));
};
const mapStoreToProps = (store) => ({
    userData: store.getValue("userData"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(NextStayCountDown);
